module.exports = __webpack_public_path__ + "static/media/competitiveadult.eecffeeb.png";